import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fc1c312"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "table-header-fixed",
  ref: "tableHeaderRef"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "index-header"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 2,
  class: "sort-icon"
}
const _hoisted_6 = {
  key: 0,
  class: "loading-mask"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["data-symbol", "onClick", "onDblclick"]
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 7 }
const _hoisted_12 = { key: 12 }
const _hoisted_13 = { key: 13 }
const _hoisted_14 = { key: 14 }
const _hoisted_15 = { key: 15 }
const _hoisted_16 = { key: 16 }
const _hoisted_17 = { key: 17 }
const _hoisted_18 = {
  key: 0,
  class: "load-more-row"
}
const _hoisted_19 = ["colspan"]
const _hoisted_20 = {
  key: 0,
  class: "loading-text"
}
const _hoisted_21 = {
  key: 1,
  class: "no-more-text"
}
const _hoisted_22 = {
  key: 1,
  class: "empty-row"
}
const _hoisted_23 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderSettingsPanel = _resolveComponent("HeaderSettingsPanel")!
  const _component_Nodata = _resolveComponent("Nodata")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["pool-table", _ctx.theme]),
    ref: "tableWrapperRef"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", null, [
        _createElementVNode("colgroup", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayColumns, (col) => {
            return (_openBlock(), _createElementBlock("col", {
              key: col.key,
              style: _normalizeStyle({ width: typeof col.width === 'number' ? col.width + 'px' : col.width })
            }, null, 4))
          }), 128))
        ]),
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayColumns, (col, colIndex) => {
              return (_openBlock(), _createElementBlock("th", {
                key: col.key,
                class: _normalizeClass([
              _ctx.getAlignClass(col.align),
              { 'fixed-left': col.fixed === 'left', 'sortable': col.sortable }
            ]),
                style: _normalizeStyle(col.fixed === 'left' ? { left: _ctx.getFixedLeft(colIndex) + 'px' } : {}),
                onClick: ($event: any) => (col.sortable ? _ctx.handleSort(col.key) : null)
              }, [
                (col.key === 'index')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                      _createTextVNode(_toDisplayString(col.title) + " ", 1),
                      _createElementVNode("span", {
                        class: "settings-icon",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openHeaderSettings && _ctx.openHeaderSettings(...args)), ["stop"])),
                        onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.settingsIconHover = true)),
                        onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.settingsIconHover = false)),
                        title: "表头设置"
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.settingsIconSrc,
                          width: "14",
                          height: "14",
                          alt: "设置"
                        }, null, 8, _hoisted_4)
                      ], 32)
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(col.title), 1)
                    ], 64)),
                (col.sortable && _ctx.sortField === col.key)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.sortOrder === 'ascend' ? '↑' : '↓'), 1))
                  : _createCommentVNode("", true)
              ], 14, _hoisted_2))
            }), 128))
          ])
        ])
      ])
    ], 512),
    _createVNode(_component_HeaderSettingsPanel, {
      visible: _ctx.headerSettingsVisible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.headerSettingsVisible) = $event)),
      columns: _ctx.draggableColumns,
      defaultColumns: _ctx.defaultDraggableColumns,
      theme: _ctx.theme as 'light' | 'dark',
      onApply: _ctx.handleHeaderSettingsApply,
      onCancel: _ctx.handleHeaderSettingsCancel
    }, null, 8, ["visible", "columns", "defaultColumns", "theme", "onApply", "onCancel"]),
    _createElementVNode("div", {
      class: "table-container",
      ref: "tableBodyRef",
      onScroll: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
      style: _normalizeStyle(_ctx.tableContainerStyle)
    }, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
        : _createCommentVNode("", true),
      _createElementVNode("table", null, [
        _createElementVNode("colgroup", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayColumns, (col) => {
            return (_openBlock(), _createElementBlock("col", {
              key: col.key,
              style: _normalizeStyle({ width: typeof col.width === 'number' ? col.width + 'px' : col.width })
            }, null, 4))
          }), 128))
        ]),
        _createElementVNode("tbody", null, [
          (_ctx.dataSource.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSource, (record, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: record.symbol,
                    "data-symbol": record.symbol,
                    onClick: ($event: any) => (_ctx.handleRowClick(record)),
                    onDblclick: ($event: any) => (_ctx.handleRowDblClick(record))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayColumns, (col, colIndex) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: col.key,
                        class: _normalizeClass([
                `col-${col.key}`,
                { 'fixed-left': col.fixed === 'left' },
                _ctx.getCellClass()
              ]),
                        style: _normalizeStyle(_ctx.getCellStyle(col, colIndex, record))
                      }, [
                        (col.key === 'index')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(index + 1), 1)
                            ], 64))
                          : (col.key === 'symbol')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_ctx.getDisplayCode(record.symbol)), 1)
                              ], 64))
                            : (col.key === 'name')
                              ? (_openBlock(), _createElementBlock("strong", _hoisted_10, _toDisplayString(_ctx.getDisplayName(record.name)), 1))
                              : (col.key === 'macd')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                    _createTextVNode(_toDisplayString(_ctx.getMacdText(record.macd)), 1)
                                  ], 64))
                                : (col.key === 'amount' && !_ctx.isMengzhuTrend)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                      _createTextVNode(_toDisplayString(_ctx.getAmountText(record.amount)), 1)
                                    ], 64))
                                  : (col.key === 'amount' && _ctx.isMengzhuTrend)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                        _createTextVNode(_toDisplayString(_ctx.getMengzhuAmountText(record.amount)), 1)
                                      ], 64))
                                    : (col.key === 'plateName' && !_ctx.isMengzhuTrend)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                          (record.plateType)
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 0,
                                                class: _normalizeClass(['plate-tag', { 'plate-tag-unselected': String(record.plateType) === '0' || !record.plateType }]),
                                                style: _normalizeStyle(_ctx.getPlateStyle(record.plateType))
                                              }, _toDisplayString(_ctx.getPlateText(record.plateType, record.plateName)), 7))
                                            : (_openBlock(), _createElementBlock("span", {
                                                key: 1,
                                                class: _normalizeClass(['plate-tag', { 'plate-tag-unselected': String(record.plateType) === '0' || !record.plateType }])
                                              }, _toDisplayString(_ctx.getPlateText(record.plateType, record.plateName)), 3))
                                        ], 64))
                                      : (col.key === 'plateName' && _ctx.isMengzhuTrend)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(record.plate?.name || record.plateName || '--'), 1))
                                        : (col.key === 'state')
                                          ? (_openBlock(), _createElementBlock("span", {
                                              key: 8,
                                              style: _normalizeStyle({ color: _ctx.getChipStateColorStyle(record.state, record.stateColor) })
                                            }, _toDisplayString(record.state || '--'), 5))
                                          : (col.key === 'shape')
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 9,
                                                style: _normalizeStyle({ color: _ctx.getChipShapeColorStyle() })
                                              }, _toDisplayString(record.shape || '--'), 5))
                                            : (col.key === 'inPoolTime')
                                              ? (_openBlock(), _createElementBlock("span", {
                                                  key: 10,
                                                  style: _normalizeStyle({ color: _ctx.getInPoolTimeColorStyle() })
                                                }, _toDisplayString(_ctx.formatInPoolTimeValue(record.inPoolTime)), 5))
                                              : (col.key === 'fundStatus')
                                                ? (_openBlock(), _createElementBlock("span", {
                                                    key: 11,
                                                    style: _normalizeStyle({ color: _ctx.getFundStatusColorStyle(record.fundStatus) })
                                                  }, _toDisplayString(_ctx.getFundStatusText(record.fundStatus)), 5))
                                                : (col.key === 'sellTime')
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.formatMengzhuDateValue(record.sellTime)), 1))
                                                  : (col.key === 'buyTime')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.formatMengzhuDateValue(record.buyTime)), 1))
                                                    : (col.key === 'maxRate' && _ctx.isMengzhuTrend)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.formatMengzhuMaxRate(record.maxRate)), 1))
                                                      : (col.key === 'cumRate')
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.formatMengzhuCumRate(record.cumRate, _ctx.currentMengzhuMainTab)), 1))
                                                        : (col.key === 'lastPx')
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.formatLastPx(record.lastPx)), 1))
                                                          : (col.key === 'pxChangRate')
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.formatPxChangRate(record.lastPx, record.pxChangRate)), 1))
                                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 18 }, [
                                                                _createTextVNode(_toDisplayString(_ctx.formatCellValue(record[col.key], col.formatter)), 1)
                                                              ], 64))
                      ], 6))
                    }), 128))
                  ], 40, _hoisted_9))
                }), 128)),
                (_ctx.loadingMore || (!_ctx.hasMore && _ctx.dataSource.length >= 100))
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                      _createElementVNode("td", {
                        colspan: _ctx.displayColumns.length,
                        class: "load-more-cell"
                      }, [
                        (_ctx.loadingMore)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, "加载中..."))
                          : (!_ctx.hasMore)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, "没有更多数据了"))
                            : _createCommentVNode("", true)
                      ], 8, _hoisted_19)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                  _createElementVNode("td", {
                    colspan: _ctx.displayColumns.length,
                    class: "empty-cell"
                  }, [
                    _createVNode(_component_Nodata, {
                      mode: "vertical",
                      customdesc: "暂无数据",
                      pagetheme: _ctx.theme
                    }, null, 8, ["pagetheme"])
                  ], 8, _hoisted_23)
                ]))
              : _createCommentVNode("", true)
        ])
      ])
    ], 36)
  ], 2))
}